import template from './siteVersionLabel.html';
import controller from './siteVersionLabel.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
  },
};

export default component;
